import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { API_ROOT, API_ROOT2 } from './config'
import i18n from '../constants/lang/i18n'

// import { toFormdata } from '../constants/global/util'

Vue.use(VueAxios, axios)

const apiLocaleMap = { 'tc': 'zh', 'en': 'en', 'ja': 'jp' }

// auto complete
export const getSearchPhenotype = (query, config) => Vue.axios.get(API_ROOT + 'ac/phenotypes', { params: { ...config, q: query, locale: i18n.locale } })
export const getSearchGeneEntry = (query, config) => Vue.axios.get(API_ROOT + 'ac/demo_gene_panel_entries', { params: { ...config, q: query, locale: i18n.locale } })
// user
export const getUserToken = (config) => Vue.axios.get(API_ROOT + 'users/current_user', { params: config })
// phenotype disease
export const getDisimJob = (id, config) => Vue.axios.get(API_ROOT + 'demo/pgd_query_jobs/' + id, { params: { ...config, locale: i18n.locale } })
export const postDisimJob = (identity, config) => Vue.axios.post(API_ROOT + 'demo/pgd_query_jobs', { identity: identity }, { params: { ...config, locale: i18n.locale } })
export const putDisimJob = (id, phenotypes, config) => Vue.axios.put(API_ROOT + 'demo/pgd_query_jobs/' + id, { phenotypes: phenotypes }, { params: { ...config, locale: i18n.locale } })
export const postHistoryDisimJob = (id, data, config) => Vue.axios.post(API_ROOT + 'demo/pgd_query_jobs/' + id + '/history', data, { params: { ...config, locale: i18n.locale } })
// gene page
export const getGenePanel = (id, config) => Vue.axios.get(API_ROOT + 'demo/demo_gene_panels/' + id, { params: { ...config, locale: i18n.locale } })
export const postHistoryPanel = (id, data, config) => Vue.axios.post(API_ROOT + 'demo/demo_gene_panels/' + id + '/history', data, { params: { ...config, locale: i18n.locale } })
// resource map
export const getRescoureMapDatas = () => Vue.axios.get(API_ROOT2 + 'map/map_' + apiLocaleMap[i18n.locale], { params: { locale: i18n.locale } })



// WEBPACK FOOTER //
// ./src/api/index.js